window.POC = window.POC || {};

(function installProductDemoRuntimeFixV5FullSearch() {
  if (!window.POC) return;

  var DIRECT_API_BASE =
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc";

  function getItems(payload) {
    if (!payload) return [];

    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.products)) return payload.products;
    if (Array.isArray(payload.items)) return payload.items;
    if (Array.isArray(payload.results)) return payload.results;

    if (payload.data && typeof payload.data === "object") {
      if (Array.isArray(payload.data.data)) return payload.data.data;
      if (Array.isArray(payload.data.products)) return payload.data.products;
      if (Array.isArray(payload.data.items)) return payload.data.items;
      if (Array.isArray(payload.data.results)) return payload.data.results;
    }

    return [];
  }

  function getCategories(payload) {
    if (!payload) return [];

    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.categories)) return payload.categories;
    if (Array.isArray(payload.items)) return payload.items;
    if (Array.isArray(payload.results)) return payload.results;

    if (payload.data && typeof payload.data === "object") {
      if (Array.isArray(payload.data.categories)) {
        return payload.data.categories;
      }

      if (Array.isArray(payload.data.items)) {
        return payload.data.items;
      }
    }

    return [];
  }

  function normalizeProductPayload(payload) {
    var items = getItems(payload);

    payload = payload || {};
    payload.data = items;
    payload.products = items;
    payload.items = items;

    if (typeof payload.count !== "number") {
      payload.count = items.length;
    }

    if (typeof payload.total !== "number") {
      payload.total = Number(payload.count || items.length);
    }

    return payload;
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, {
      method: "GET",
      mode: options && options.mode ? options.mode : "cors",
      cache: "no-store",
      credentials:
        options && options.credentials
          ? options.credentials
          : "omit",
      headers: {
        Accept: "application/json"
      }
    });

    var text = await response.text();

    if (!response.ok) {
      throw new Error(
        "HTTP " + response.status + " | " + text.slice(0, 300)
      );
    }

    try {
      return JSON.parse(text);
    } catch (error) {
      throw new Error(
        "Invalid JSON response: " + text.slice(0, 300)
      );
    }
  }

  function buildCategoryProductsUrl(base, categoryId, skip, take) {
    var id = String(categoryId || "ALL");

    return (
      base +
      "/products/by-category" +
      "?category=" + encodeURIComponent(id) +
      "&categoryId=" + encodeURIComponent(id) +
      "&skip=" + encodeURIComponent(String(skip || 0)) +
      "&take=" + encodeURIComponent(String(take || 48)) +
      "&cb=" + Date.now()
    );
  }

  function buildCategoriesUrl(base) {
    return (
      base +
      "/categories?diag=1&cb=" +
      Date.now()
    );
  }

  async function fetchCategoriesAuthoritative() {
    var directUrl = buildCategoriesUrl(DIRECT_API_BASE);
    var proxyUrl = buildCategoriesUrl("/apps/inksoft");

    try {
      var directPayload = await fetchJson(directUrl, {
        mode: "cors",
        credentials: "omit"
      });

      var directCategories = getCategories(directPayload);

      if (directPayload && directPayload.success === true && directCategories.length) {
        console.info("[POC runtime fix v5 full-search] Direct Azure categories", {
          count: directCategories.length,
          strategy:
            directPayload.diagnostics &&
            directPayload.diagnostics.categoryCountStrategy
        });

        return directCategories;
      }
    } catch (error) {
      console.warn(
        "[POC runtime fix v5 full-search] Direct categories request failed:",
        error
      );
    }

    var proxyPayload = await fetchJson(proxyUrl, {
      mode: "same-origin",
      credentials: "same-origin"
    });

    var proxyCategories = getCategories(proxyPayload);

    console.info("[POC runtime fix v5 full-search] Shopify proxy categories", {
      count: proxyCategories.length,
      strategy:
        proxyPayload.diagnostics &&
        proxyPayload.diagnostics.categoryCountStrategy
    });

    if (
      !proxyPayload ||
      proxyPayload.success !== true ||
      !proxyCategories.length
    ) {
      throw new Error("Invalid categories response");
    }

    return proxyCategories;
  }

  async function fetchCategoryProducts(categoryId, skip, take) {
    var directUrl = buildCategoryProductsUrl(
      DIRECT_API_BASE,
      categoryId,
      skip,
      take
    );

    var proxyUrl = buildCategoryProductsUrl(
      "/apps/inksoft",
      categoryId,
      skip,
      take
    );

    var directPayload = null;

    try {
      directPayload = normalizeProductPayload(
        await fetchJson(directUrl, {
          mode: "cors",
          credentials: "omit"
        })
      );

      console.info("[POC runtime fix v5 full-search] Direct Azure products", {
        categoryId: String(categoryId || "ALL"),
        total: directPayload.total,
        count: getItems(directPayload).length
      });

      if (
        directPayload.success === true &&
        (
          String(categoryId || "ALL") === "ALL" ||
          Number(directPayload.total || 0) > 0 ||
          getItems(directPayload).length > 0
        )
      ) {
        return directPayload;
      }
    } catch (error) {
      console.warn(
        "[POC runtime fix v5 full-search] Direct product request failed:",
        error
      );
    }

    var proxyPayload = normalizeProductPayload(
      await fetchJson(proxyUrl, {
        mode: "same-origin",
        credentials: "same-origin"
      })
    );

    console.info("[POC runtime fix v5 full-search] Shopify proxy products", {
      categoryId: String(categoryId || "ALL"),
      total: proxyPayload.total,
      count: getItems(proxyPayload).length
    });

    if (proxyPayload.success !== true) {
      throw new Error("Invalid products response");
    }

    if (
      Number(proxyPayload.total || 0) <= 0 &&
      getItems(proxyPayload).length === 0 &&
      directPayload &&
      directPayload.success === true &&
      (
        Number(directPayload.total || 0) > 0 ||
        getItems(directPayload).length > 0
      )
    ) {
      return directPayload;
    }

    return proxyPayload;
  }

  async function fetchAllCategoryProducts(categoryId) {
    var id = String(categoryId || "ALL");
    var pageSize = 96;
    var skip = 0;
    var total = 0;
    var items = [];
    var seen = {};
    var safety = 0;

    while (safety < 50) {
      safety += 1;

      var page = await fetchCategoryProducts(id, skip, pageSize);
      var pageItems = getItems(page);

      if (!total) {
        total = Number(page.total || page.count || pageItems.length || 0);
      }

      pageItems.forEach(function (product, index) {
        var key = String(
          product && (
            product.id || product.ID || product.Id ||
            product.productId || product.ProductId ||
            product.sku || product.SKU || product.ProductSKU ||
            ("row-" + (skip + index))
          )
        );

        if (seen[key]) return;
        seen[key] = true;
        items.push(product);
      });

      skip += pageItems.length;

      var hasMore = page.hasMore === true || (total > 0 && items.length < total);
      if (!pageItems.length || !hasMore) break;
    }

    return normalizeProductPayload({
      success: true,
      categoryId: id,
      total: items.length,
      count: items.length,
      skip: 0,
      take: items.length,
      hasMore: false,
      data: items,
      products: items,
      items: items,
      fullDatasetLoaded: true
    });
  }

  function bindLocalLoadMoreEvents() {
    var button = document.getElementById("poc-demo-load-more");
    if (!button || button.dataset.fullSearchBound === "true") return;

    button.dataset.fullSearchBound = "true";
    button.addEventListener("click", function () {
      if (POC.core && typeof POC.core.increaseVisibleCount === "function") {
        POC.core.increaseVisibleCount();
      } else {
        POC.state = POC.state || {};
        POC.state.pagination = POC.state.pagination || {};
        var current = Number(POC.state.pagination.visibleCount || 48);
        var batch = Number(POC.state.pagination.batchSize || 48);
        POC.state.pagination.visibleCount = current + batch;
      }

      var key = String(POC.state && POC.state.selectedCategoryId || "ALL");
      var payload = POC.state && POC.state.productsByCategory
        ? POC.state.productsByCategory[key]
        : null;

      if (payload && POC.render && typeof POC.render.renderProducts === "function") {
        POC.render.renderProducts(payload);
      }
    });
  }

  function stopAllLoaders() {
    try {
      if (
        POC.core &&
        typeof POC.core.setSidebarAllLoading === "function"
      ) {
        POC.core.setSidebarAllLoading(false);
      }
    } catch (error) {
      console.warn(
        "[POC runtime fix v5 full-search] Failed to clear sidebar loading state:",
        error
      );
    }

    if (POC.state) {
      POC.state.sidebar = POC.state.sidebar || {};
      POC.state.sidebar.loadingAll = false;
    }

    var categoryTree =
      document.getElementById("poc-demo-category-tree");
    if (categoryTree) {
      categoryTree.style.visibility = "visible";
      categoryTree.style.display = "";
      categoryTree.removeAttribute("aria-busy");
    }

    var allButton =
      document.querySelector('[data-category-id="ALL"]');
    if (allButton) {
      allButton.classList.remove("is-loading");
      allButton.removeAttribute("aria-busy");
    }

    var categoriesPanel =
      document.getElementById("poc-demo-categories");
    if (categoriesPanel) {
      categoriesPanel.classList.remove("is-loading");
      categoriesPanel.removeAttribute("aria-busy");
    }

    if (POC.ui && typeof POC.ui.hideLoader === "function") {
      POC.ui.hideLoader();
    }

    var globalLoader =
      document.getElementById("poc-demo-loader");
    if (globalLoader) {
      globalLoader.style.display = "none";
      globalLoader.setAttribute("aria-hidden", "true");
    }
  }

  function resetFilters() {
    POC.state = POC.state || {};
    POC.state.filters = POC.state.filters || {};

    POC.state.filters.search = "";
    POC.state.filters.curatedOnly = false;
    POC.state.filters.curatedFilter = "ALL";
    POC.state.filters.brand = "";
    POC.state.filters.color = "";
    POC.state.filters.size = "";
  }

  async function loadCategoryFixed(
    categoryId,
    categoryName,
    showLoading
  ) {
    POC.state = POC.state || {};
    POC.state.productsByCategory =
      POC.state.productsByCategory || {};
    POC.state.paging = POC.state.paging || {
      skip: 0,
      take: 48,
      total: 0,
      hasMore: false,
      loadingMore: false
    };

    var id = String(categoryId || "ALL");
    var name = String(
      categoryName ||
      (id === "ALL" ? "All Products" : "Products")
    );
    var take = Number(POC.state.paging.take || 48);

    POC.state.selectedCategoryId = id;
    POC.state.selectedCategoryName = name;
    POC.state.hasLoadedProducts = true;

    resetFilters();

    if (
      POC.core &&
      typeof POC.core.syncToolbarFromState === "function"
    ) {
      POC.core.syncToolbarFromState();
    }

    if (
      showLoading !== false &&
      POC.ui &&
      typeof POC.ui.setProductsStatus === "function"
    ) {
      POC.ui.setProductsStatus("Loading products…", "loading");
      var loadingStatus =
        document.getElementById("poc-demo-products-status");
      if (loadingStatus) loadingStatus.style.display = "";
    }

    try {
      var payload = await fetchAllCategoryProducts(id);
      var items = getItems(payload);

      POC.state.productsByCategory[id] = payload;
      POC.state.paging.skip = 0;
      POC.state.paging.total =
        Number(payload.total || items.length);
      POC.state.paging.hasMore = false;

      if (
        POC.render &&
        typeof POC.render.renderProducts === "function"
      ) {
        POC.render.renderProducts(payload);
      }

      if (
        POC.render &&
        typeof POC.render.renderCategories === "function"
      ) {
        POC.render.renderCategories(
          POC.state.categories || []
        );
      }

      if (
        POC.render &&
        typeof POC.render.renderCompareTray === "function"
      ) {
        POC.render.renderCompareTray();
      }

      if (
        POC.core &&
        typeof POC.core.bindCompareEvents === "function"
      ) {
        POC.core.bindCompareEvents();
      }

      bindLocalLoadMoreEvents();

      var status =
        document.getElementById("poc-demo-products-status");
      if (status) status.style.display = "none";

      if (
        POC.ui &&
        typeof POC.ui.setGlobalStatus === "function"
      ) {
        POC.ui.setGlobalStatus("", "");
      }

      stopAllLoaders();

      console.info("[POC runtime fix v5 full-search] Loaded category", {
        categoryId: id,
        categoryName: name,
        total: payload.total,
        count: items.length
      });

      return payload;
    } catch (error) {
      stopAllLoaders();

      console.error(
        "[POC runtime fix v5 full-search] Category load failed:",
        error
      );

      if (
        POC.ui &&
        typeof POC.ui.setProductsStatus === "function"
      ) {
        POC.ui.setProductsStatus(
          "Failed to load products. " +
            (error && error.message ? error.message : ""),
          "error"
        );

        var errorStatus =
          document.getElementById("poc-demo-products-status");
        if (errorStatus) errorStatus.style.display = "";
      }

      throw error;
    }
  }

  async function refreshAuthoritativeCategories() {
    var categories = await fetchCategoriesAuthoritative();

    POC.state.categories = categories;

    if (
      POC.render &&
      typeof POC.render.renderCategories === "function"
    ) {
      POC.render.renderCategories(categories);
    }

    stopAllLoaders();

    console.info(
      "[POC runtime fix v5 full-search] Replaced category tree",
      { topLevelCount: categories.length }
    );

    return categories;
  }

  function install() {
    if (!POC.core || !POC.api || !POC.render) {
      window.setTimeout(install, 50);
      return;
    }

    POC.api.getCategories = fetchCategoriesAuthoritative;

    POC.api.getProductsByCategory = function (
      categoryId,
      options
    ) {
      return fetchCategoryProducts(
        categoryId,
        options && options.skip ? options.skip : 0,
        options && options.take ? options.take : 48
      );
    };

    POC.core.loadCategory = loadCategoryFixed;
    POC.core.bindLoadMoreEvents = bindLocalLoadMoreEvents;

    window.POC_PRODUCT_RUNTIME_FIX_V5_FULL_SEARCH_ACTIVE = true;
    console.info("[POC runtime fix v5 full-search] Installed");

    window.setTimeout(async function () {
      try {
        await refreshAuthoritativeCategories();

        var currentId = String(
          POC.state &&
          POC.state.selectedCategoryId ||
          "ALL"
        );

        var currentName = String(
          POC.state &&
          POC.state.selectedCategoryName ||
          (currentId === "ALL"
            ? "All Products"
            : "Products")
        );

        await loadCategoryFixed(
          currentId,
          currentName,
          false
        );
      } catch (error) {
        console.error(
          "[POC runtime fix v5 full-search] Initial refresh failed:",
          error
        );
      } finally {
        stopAllLoaders();

        // The original core can finish slightly later and restore its
        // loading flag, so clear it once more after the init race settles.
        window.setTimeout(stopAllLoaders, 500);
        window.setTimeout(stopAllLoaders, 1500);
      }
    }, 350);
  }

  install();
})();